"use strict";
exports.__esModule = true;
exports.isSecurityOrderTypeUnit = exports.isSecurityOrderTypeDollar = exports.SecurityOrderType = void 0;
var SecurityOrderType;
(function (SecurityOrderType) {
    SecurityOrderType["DOLLAR_ORDER"] = "DOLLAR_ORDER";
    SecurityOrderType["UNIT_ORDER"] = "UNIT_ORDER";
    SecurityOrderType["DOLLAR_ALL"] = "DOLLAR_ALL";
    SecurityOrderType["UNIT_ALL"] = "UNIT_ALL";
})(SecurityOrderType = exports.SecurityOrderType || (exports.SecurityOrderType = {}));
function isSecurityOrderTypeDollar(securityOrderType) {
    return securityOrderType === SecurityOrderType.DOLLAR_ORDER || securityOrderType === SecurityOrderType.DOLLAR_ALL;
}
exports.isSecurityOrderTypeDollar = isSecurityOrderTypeDollar;
function isSecurityOrderTypeUnit(securityOrderType) {
    return securityOrderType === SecurityOrderType.UNIT_ORDER || securityOrderType === SecurityOrderType.UNIT_ALL;
}
exports.isSecurityOrderTypeUnit = isSecurityOrderTypeUnit;
